// Usercentrics → Shopify consent bridge
window.addEventListener("UC_UI_CMP_EVENT", function(e) {
  if (e.detail && (e.detail.type === "ACCEPT_ALL" || e.detail.type === "SAVE" || e.detail.type === "DENY_ALL")) {
    var allowed = e.detail.type === "ACCEPT_ALL";
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
      window.Shopify.customerPrivacy.setTrackingConsent(allowed, function() {});
    }
  }
});

// Clarity with consent gating + polling fallback
(function initClarity() {
  var clarityLoaded = false;
  function loadClarity() {
    if (clarityLoaded) return;
    clarityLoaded = true;
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window,document,"clarity","script","xb4323yci9");
  }

  function checkConsent() {
    if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
      loadClarity();
    }
  }

  checkConsent();
  document.addEventListener("visitorConsentCollected", checkConsent);
  window.addEventListener("UC_UI_CMP_EVENT", checkConsent);

  var attempts = 0;
  var interval = setInterval(function() {
    checkConsent();      if (clarityLoaded || ++attempts >= 20) clearInterval(interval);
  }, 500);
})();
